export const getNearestVersionDate = (versions: string[]): string | undefined => {
  if (versions.length === 0) return undefined;

  const toDateString = (date: Date): string => date.toISOString().slice(0, 10);

  const todayStr = toDateString(new Date());

  const validDates = versions
    .map(v => ({ str: v, date: new Date(v) }))
    .filter(({ date }) => !isNaN(date.getTime()))
    .sort((a, b) => a.date.getTime() - b.date.getTime());

  if (validDates.length === 0) return undefined;

  const todayVersion = validDates.find(({ str }) => str === todayStr);
  if (todayVersion) return todayStr;

  const today = new Date(todayStr);
  const pastDates = validDates.filter(({ date }) => date.getTime() < today.getTime());

  return pastDates.length > 0
    ? toDateString(pastDates[pastDates.length - 1].date)
    : toDateString(validDates[0].date);
};
